import { render, staticRenderFns } from "./AdminObjectArchiveSearch.vue?vue&type=template&id=6eacf9a5&"
import script from "./AdminObjectArchiveSearch.vue?vue&type=script&lang=js&"
export * from "./AdminObjectArchiveSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports